import { isProduct } from '@/const';
import { boot } from '@/utils/Platform';
import { initUserTrack } from '@/utils/userTrack';
import track from '@relx/shence';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
// import 'normalize.css';
import './index.less';
import './theme.less';
export * from '@/aop';

boot();
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
if (isProduct) {
  initUserTrack();
}
Sentry.init({
  dsn: 'https://d525cf6060a54875a59adc60dfdd0bd4@sentry.relxtech.com/5',
  environment: isProduct ? 'production' : 'test',
  // integrations: [new BrowserTracing()],
  integrations: [
    new Sentry.BrowserProfilingIntegration(),
    new Sentry.BrowserTracing(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 1.0,
});
const token =
  'd89b68c35219fa73ab65fe44222528e863030e5a400228d115e402d73e9402c0';
const SERVICE_URL = isProduct
  ? `https://servicesensors.relxtech.com/sa?project=RelxDeer_production&token=${token}`
  : `https://servicesensors.relxtech.com/sa?project=default&token=${token}`;

track({
  server_url: SERVICE_URL,
  singlePage: false,
  wxAppId: isProduct ? 'wx50ef8008960887e1' : 'wx400e83da07518100',
  isGetGps: false,
  isGoWxAuth: true,
  globalProperties: {
    storeBrand: 'relx',
  },
});
